import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation, Trans } from "react-i18next";

function NotFound() {
  const { t } = useTranslation();
  const [logoSqImg, setLogoSqImg] = useState('');

  useEffect(() => {
    setLogoSqImg('assets/img/common/logo-error-page.png');
  }, []);
  
  return (
    <section className="unavailable">
      <style jsx="true">
        {`
          .unavailable {
            width: 60%;
            margin: 4em auto;
            text-align: center;
            background-size: 100% 100%;
            background-position: center bottom;
          }
            .unavailable img {
              width: 120px;
              height: auto;
            }
            .unavailable h1 {
              font-size: 38px;
              margin-top: 1em;
              font-weight: bold;
              line-height: 3em;
            }
            .unavailable .unavailable-page p {
              text-align: center;
              line-height: 1.6em;
              margin-bottom: 1.6em;
            }
            .unavailable-page .btn-basic {
              position: relative;
              background: #666;
              margin-top: 3rem;
              text-align: center;
              color: #fff;
              line-height: 2em;
              padding: 1em;
              border-radius: 40px;
              text-decoration: none;
              font-weight: bold;
            }
            @media (max-width: 1149px) {
              .unavailable {
                width: 80%;
              }
              .unavailable h1 {
                font-size: 24px;
              }
            }
        `}
      </style>
      <>
      <div className="unavailable-page">
        <img src={logoSqImg} />
        <h1>{t("notFound.title")}</h1>
        <p><Trans i18nKey="notFound.text" /></p>
        <a href="/" className="btn-basic">{t("notFound.btnName")}</a>
      </div>
      </>
    </section>
  );
}

const mapStateToProps = state => {
  return {
    language: state.piano.language,
  };
};

export default connect(mapStateToProps)(NotFound);
